import { Slot } from "radix-ui"

import { cn } from "@/shared/lib/utils"

import { buttonVariants, type ButtonVariantsProps } from "./button-variants"

export interface ButtonProps extends ButtonVariantsProps, React.ComponentProps<"button"> {
  asChild?: boolean
}

export const Button: React.FC<ButtonProps> = ({ className, variant, size, asChild = false, ...props }) => {
  const Component = asChild ? Slot.Root : "button"

  return (
    <Component
      // Default `type="button"` so a `<Button>` inside a `<form>` never accidentally
      // submits the form on click. Callers that need submit semantics pass `type="submit"`
      // explicitly — the spread below overrides this default.
      type="button"
      {...props}
      className={cn(buttonVariants({ variant, size, className }))}
    />
  )
}

Button.displayName = "Button"
